import { gql } from '@apollo/client'

export const REQUEST_AN_ACCOUNT = gql`
  mutation CreateAccount(
    $organizationName: String!
    $partyId: String
    $firstName: String!
    $lastName: String!
    $email: String!
    $phoneNumber: String!
    $businessSponsorFirstName: String!
    $businessSponsorLastName: String!
    $businessSponsorEmail: String!
    $businessSponsorPhoneNumber: String
    $kind: String
  ) {
    createSandboxAccount(
      data: {
        organizationName: $organizationName
        firstName: $firstName
        lastName: $lastName
        email: $email
        phoneNumber: $phoneNumber
        businessSponsorFirstName: $businessSponsorFirstName
        businessSponsorLastName: $businessSponsorLastName
        businessSponsorEmail: $businessSponsorEmail
        businessSponsorPhoneNumber: $businessSponsorPhoneNumber
        kind: $kind
        partyId: $partyId
      }
    ) {
      userId
      firstName
      lastName
      email
      phoneNumber
      businessSponsorFirstName
      businessSponsorLastName
      businessSponsorEmail
      businessSponsorPhoneNumber
    }
  }
`
